import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

import { ItemGroup } from '../../../_models/common/item.group';
import { AdminService } from '../../../_services/admin/admin.service';

@Component({
  selector: 'app-admin-typeahead-item-group-search',
  templateUrl: './admin-typeahead-item-group-search.component.html',
  styleUrls: ['./admin-typeahead-item-group-search.component.scss']
})
export class AdminTypeaheadItemGroupSearchComponent implements OnInit {
  @Input() label: string;
  @Input() start: string;
  @Input() wholesaler: number;
  @Output() selected: EventEmitter<ItemGroup> = new EventEmitter<ItemGroup>();
  @Output() blur: EventEmitter<string> = new EventEmitter<string>();
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() labelCols: number;
  @Input() dividerKind: number;
  @Input() focusInput: EventEmitter<boolean>;
  @Input() emptyAfterSelected: boolean = false;
  @Input() dropup: boolean = false;
  uniqueId = Math.random().toString(36).substring(2);

  constructor(
    public adminService: AdminService
  ) { }

  ngOnInit() {
    if (!this.focusInput) { this.focusInput = new EventEmitter<boolean>(); }
    if (this.labelCols!==0 && !this.labelCols) { this.labelCols = 2; }
  }

  typeaheadOnSelect(match: TypeaheadMatch) {
    this.selected.emit(match.item);
    if (this.emptyAfterSelected) {
      setTimeout(() => this.start = '', 10);
    }
  }

  onBlur(event: FocusEvent) {
    setTimeout(() => this.blur.emit(this.start), 500);
  }

}
